/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Select_All_PageInputs */

const cs_users_select_all_page = /** @type {(inputs: Users_Select_All_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat vše na stránce`)
};

const en_users_select_all_page = /** @type {(inputs: Users_Select_All_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all on page`)
};

/**
* | output |
* | --- |
* | "Select all on page" |
*
* @param {Users_Select_All_PageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_select_all_page = /** @type {((inputs?: Users_Select_All_PageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Select_All_PageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_select_all_page(inputs)
	return cs_users_select_all_page(inputs)
});